import { ReactElement, useCallback, useEffect, useState } from 'react';

import { useConnection } from 'modules/auth/hooks/useConnection';
import { KnownDialogs, useDialog } from 'modules/dialogs';
import { StakeSuccessDialog } from 'modules/liquidStaking/components/StakeSuccessDialog/StakeSuccessDialog';
import { EMPTY_MODAL_SUCCESS_STATE } from 'modules/liquidStaking/const';
import { IModalSuccessState } from 'modules/liquidStaking/types';

import { useStakeMutation } from '../actions/stake';
import { IStakeFormProps, StakeForm } from './StakeForm';

export function Stake(): ReactElement | null {
  const [stake, { isLoading, data: txHash, reset }] = useStakeMutation();
  const { isSafeAccount } = useConnection();

  const [formKey, setFormKey] = useState(0);
  const handleReset = useCallback(() => {
    reset();
    setFormKey(prev => prev + 1);
    setSuccessState(EMPTY_MODAL_SUCCESS_STATE);
  }, [reset]);

  const { onOpen, isOpened } = useDialog<IModalSuccessState>(
    KnownDialogs.tabStakeSuccess,
  );
  const [successState, setSuccessState] = useState<IModalSuccessState>(
    EMPTY_MODAL_SUCCESS_STATE,
  );

  useEffect(() => {
    if (!isLoading && txHash && !isOpened && !isSafeAccount) {
      onOpen({ ...successState, txHash });
    }
  }, [txHash, isLoading, isOpened, onOpen, successState, isSafeAccount]);

  const handleSubmit: IStakeFormProps['onSubmit'] = useCallback(
    ({ amount, receiveAmount }) => {
      void stake({
        amount,
      });
      setSuccessState({ inAmount: amount, outAmount: receiveAmount });
    },
    [stake],
  );

  return (
    <>
      <StakeForm
        key={formKey}
        isSubmitLoading={isLoading}
        onSubmit={handleSubmit}
      />

      {isOpened && <StakeSuccessDialog onClose={handleReset} />}
    </>
  );
}
